import { fileOf, rankOf, squareToAlgebraic } from "./board";
import type { Move } from "./types";

const FILES = "abcdefgh";

/** Notation algebrique standard (SAN) d'un coup, sans le suffixe +/# (ajoute par l'appelant, qui connait l'etat resultant). */
export function moveToSanBase(move: Move, legalMovesInPosition: readonly Move[]): string {
  if (move.castle === "k") return "O-O";
  if (move.castle === "q") return "O-O-O";

  const isCapture = !!move.captured || move.enPassantCapture !== undefined;
  const destination = squareToAlgebraic(move.to);

  if (move.piece.type === "p") {
    const base = isCapture ? `${FILES[fileOf(move.from)]}x${destination}` : destination;
    return move.promotion ? `${base}=${move.promotion.toUpperCase()}` : base;
  }

  const pieceLetter = move.piece.type.toUpperCase();
  const others = legalMovesInPosition.filter(
    (other) => other.piece.type === move.piece.type && other.to === move.to && other.from !== move.from,
  );

  let disambiguator = "";
  if (others.length > 0) {
    const sameFile = others.some((other) => fileOf(other.from) === fileOf(move.from));
    const sameRank = others.some((other) => rankOf(other.from) === rankOf(move.from));
    if (!sameFile) {
      disambiguator = FILES[fileOf(move.from)] ?? "";
    } else if (!sameRank) {
      disambiguator = String(rankOf(move.from) + 1);
    } else {
      disambiguator = squareToAlgebraic(move.from);
    }
  }

  return `${pieceLetter}${disambiguator}${isCapture ? "x" : ""}${destination}`;
}
